import { Controller } from '@hotwired/stimulus';
import { createApp } from 'vue'
import CityAutocomplete from '../../vue/city_autocomplete'

export default class extends Controller {
  static targets = ['input', 'city']

  initialize() {
    this.app = createApp(CityAutocomplete)
  }

  connect() {
    this.appNode = document.createElement('div')
    document.body.appendChild(this.appNode)
    this.vm = this.app.mount(this.appNode)

    this.inputTarget.addEventListener('click', () => this.vm.open(true))
    this.appNode.addEventListener('citySelected', (event) => this.citySelected(event.detail))
  }

  disconnect() {
    this.app.unmount()
    this.appNode.remove()
  }

  citySelected(city) {
    this.inputTarget.value = city.label
    this.cityTarget.value = city.id
  }
}
